
<div class="container-fluid">
    <div class="row"> 
        <div class="col-md-3">
            <h1 class="p-4 text-center" style="font-weight: 500;"> Open Positions</h1>
            <div class="job_list">
                <div class="job_pos p-3" *ngFor="let job of openjobs">
                    <h3 class="job_des"> {{ job.designation}} </h3>
                    <p><fa-icon [icon]="faMapMarkerAlt" style="color: coral;"></fa-icon> {{  job.location }} </p>
                    <button class="viewBtn p-2" (click)="viewJob(job.id)"> View </button>
                </div>
            </div> 
        </div>
         
        <div class="col-md-9 job_detail_container" id="job_view" >
            <div *ngIf="loader == true" style="height: 300px; display: flex; justify-content: center; align-items: center;">
                <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
            </div>
            <div *ngIf="loader == false">
                <div class="jobTitle p-4">
                    <div class="job_loc_icon">
                        <div class="col-md-8">
                            <h1 id="scroll_elem" style="font-weight: 500;">  {{ oj_designation }} </h1>
                            <p style="font-weight: 500;"><fa-icon [icon]="faMapMarkerAlt" style="color: coral;"></fa-icon> {{  oj_location }} </p>
                        </div>
                        <div class="col-md-4">
                            <button class="applyClass p-3 text-center" (click)="sendToForm()" > APPLY</button>
                        </div>
                    </div>
                    <hr>
                    <div class="details">
                        <div class="row pt-4 pb-2">
                            <div class="col-md-8">
                                <h2 class="job_head">  Job Summary  </h2>
                            </div>
                        </div>
                        <p class="pb-2"> {{ oj_description }}  </p>
                        <div class="col-5 min_exp pt-2">
                            <h3 class="job_head"> Experience Level: </h3>
                            <h3>  {{ oj_min_yoe }} - {{ oj_max_yoe }} Years </h3>
                        </div>
                        <div class="col-5 min_exp pt-2">
                            <h3 class="job_head"> Job Type: </h3>
                            <h3> {{ oj_typeDesc }} </h3>
                        </div> 
                    </div>  
                </div> 
                <div class="jobDetails p-4">
                    <h2 class="job_head"> Job Details  </h2>
                    <p class="mt-3">{{ oj_role }}  </p>
                </div>
                <div class="minQualification p-4">
                    <h2 class="job_head">  Minimum Qualification  </h2>
                    <p class="mt-3"> {{ oj_qualifications }} </p>
                </div>
                <div class="p-4" id="submit_form">
                    <h2 class="job_head">  Submit Application  </h2>
                </div>
                <div class="pl-4 pr-4">
                    <form class="p-4 career_form" role="form">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <input class="form-control" name="name_1" placeholder="First Name" type="text" [ngModel]="careers.firstname" (ngModelChange)="changeFirstName($event)">
                            </div>
                            <div class="form-group col-md-6">
                                <input class="form-control" name="email_1" placeholder="Last Name" type="text" [ngModel]="careers.lastname" (ngModelChange)="changeLastName($event)" >
                            </div>
        
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <input class="form-control" name="phone_1" placeholder="Email" type="text" [ngModel]="careers.email" (ngModelChange)="changeEmail($event)">
                            </div>
                            <div class="form-group col-md-6">
                                <input class="form-control" name="address_1" placeholder="Phone" type="text" [ngModel]="careers.phone" (ngModelChange)="changePhone($event)">
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6 file_upload_container">
                                <input type="file" class="upload_box" (change)="onChangeResumeUpload($event)" placeholder="Upload file" accept=".pdf,.doc,.docx">
                            </div> 
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12" style="display: flex; justify-content: center;">
                                <button type="submit" (click)="applyForJob()" class="applyBtn p-3">Submit</button>
                            </div>
                        </div> 
                    </form>   
                </div>  
            </div> 
        </div>
    </div> 
</div>
<div class="form_sub_msg" *ngIf="form_msg == true">
    <p> {{ form_submit_msg }} </p>
</div>
  